// get ecustomer list for admin workforce
export const RESET_DISABLE_CUSTOMER = "RESET_DISABLE_CUSTOMER";
export const DISABLE_CUSTOMER = "DISABLE_CUSTOMER";
export const DISABLE_CUSTOMER_SUCCESS = "DISABLE_CUSTOMER_success";
export const DISABLE_CUSTOMER_FAILURE = "DISABLE_CUSTOMER_failure";
